<template>
  <div class="wealth-portfolio-background">
    <SearchInput
      v-model="search"
      class="wealth-portfolio-background-image__input"
      placeholder="Buscar imagem"
      data-testid="search-input"
      @input="getBackgroundImages(true)"
    />
    <div class="wealth-portfolio-background__container">
      <InfiniteScroll
        :max-per-page="10"
        :request="() => getBackgroundImages(false)"
        :item-list="images"
        data-testid="infinite-scroll"
      >
        <template #default="item">
          <div class="wealth-portfolio-background__content">
            <BaseCard
              class="wealth-portfolio-background-image__photos"
              :background="item.urls.thumb"
              :title="item.user.name"
              @click="putBackgroundImage(item)"
            />
          </div>
        </template>
      </InfiniteScroll>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SearchInput } from '@/modules/common/components/SearchInput';
import {
  getBackgroundImages,
  putBackgroundImage,
  IPhotos
} from '@/modules/wealth/services/portfolio';
import { BaseCard } from '@/modules/common/components/cards/BaseCard';
import { InfiniteScroll } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    SearchInput,
    BaseCard,
    InfiniteScroll
  }
})
export default class WealthPortfolioBackground extends Vue {
  @Prop({ type: String })
  public portfolioId!: string;

  @Prop({ type: Boolean, default: true })
  public instantSave!: boolean;

  private search = '';
  private images: IPhotos[] = [];
  private page = 1;

  private async getBackgroundImages(restartPage: boolean) {
    if (restartPage) {
      this.images = [];
      this.page = 1;
    }
    const queryInfo = {
      query: this.search,
      page: this.page++,
      perPage: 10
    };
    const { photos } = await getBackgroundImages(queryInfo);
    photos.forEach(photo => this.images.push(photo));
  }

  private async putBackgroundImage(photo: IPhotos) {
    if (this.instantSave) {
      await putBackgroundImage(this.portfolioId, photo.urls);
    }
    this.$emit(
      'background-image-changed',
      this.instantSave ? photo.urls.thumb : photo
    );
  }
}
</script>
<style lang="less" scoped>
.wealth-portfolio-background-image__input {
  width: calc((2 * @spacing-xxxxl) + @size-spacing-x800);
  left: calc(@size-spacing-x600 + @size-spacing-x300);
  position: absolute;
  height: @size-spacing-x900;
  top: @spacing-xxl;
  border-radius: 4px;
}
.wealth-portfolio-background__container {
  width: 100%;
  height: calc(5.2 * @spacing-xxxxl);
  left: calc(@size-spacing-x600 + @size-spacing-x300);
  top: @size-spacing-x1000;
  overflow-y: scroll;
  margin-top: @size-spacing-x1000;
}
.wealth-portfolio-background-image__photos {
  display: flex;
  width: calc(@spacing-xxxxl + @size-spacing-x400);
  height: @spacing-xxl;
  top: @size-spacing-x300;
  margin: 0 0 2px 2px;
  left: calc(@size-spacing-x600 + @size-spacing-x300);
  align-items: stretch;
}
/deep/ .card {
  border-radius: 0px;
}
/deep/ .container-items {
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
}
/deep/ .wealth-content {
  section {
    overflow-y: hidden !important;
    z-index: 0;
  }
}
</style>
